/*==============================================================================
  
  THEME.JS
  
  ##### IMPORTANT #####
  For best performance, use this file for development. After making changes, minify 
  the file and save in `theme.min.js` for production. 

  If that's not convenient from a development perspective, then stick to using
  theme.js and ensure that's referenced in `theme.liquid`.


  
  #SLATE

  Slate A11y Helpers - slate.a11y
  Slate Utility Helpers - slate.utils
  Slate Rich Text Editor - slate.rte
  Theme Sections - theme.Sections
  Slate Currency - slate.Currency
  Slate Image - slate.Image
  Slate Variants - slate.Variants


  #CONFIG & UTILITIES

  theme.config (isTouch, mq)
  theme.mq
  theme.setBreakpoints
  theme.CartUtilities (AJAX Shopify API Utilities)
  theme.AjaxProduct (Ajax Add Product Functionality)
  theme.loadImageSection (Allows for adding classes whilst loading so we can animate)


  #MODULES

  theme.HeaderNav
  theme.Modals
  theme.Popovers
  theme.Drawers
  theme.Slideshow
  theme.Collapsibles
  theme.Tabs


  #SECTIONS

  theme.HeaderSection
  theme.DrawerMenuSection
  theme.Cart
  theme.Product
  theme.Collection
  theme.CollectionListSection
  theme.SlideshowSection
  theme.ContactSection
  theme.BlogSection
  theme.ArticleSection


  #TEMPLATES

  theme.customerAddresses
  theme.customerLogin


  #INIT

  theme.init (tab handling, init modules)


  #DOC READY

  theme.init()
  sections.register
  a11y page link focus
  slate rte tables
  slate rte iframes


==============================================================================*/





window.slate = window.slate || {};
window.theme = window.theme || {};





/*==============================================================================
  #SLATE a11y
==============================================================================*/

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }

};










/*==============================================================================
  #SLATE Utility Helpers
==============================================================================*/

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 *
 * #EDIT
 * - Added arrayIncludes and uniq utilities for linked product options
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },


  /**
   * A utility from Shopify option_selection.js needed for linked product
   * options.
   */
  arrayIncludes: function(e, t) {
    for (var n = 0; n < e.length; n++)
        if (e[n] == t) return !0;
    return !1
  }, 


  /**
   * A utility from Shopify option_selection.js needed for linked product
   * options.
   */
  uniq: function(e) {
      for (var t = [], n = 0; n < e.length; n++) slate.utils.arrayIncludes(t, e[n]) || t.push(e[n]);
      return t
  }
};










/*==============================================================================
  #SLATE Rich Text Editor
==============================================================================*/

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};










/*==============================================================================
  #THEME Sections
==============================================================================*/

/**
 * Sections
 * - Largely based on Slate and Impulse theme with some minor adjustments.
 * - https://help.shopify.com/en/themes/development/sections#understand-the-interaction-between-theme-javascript-and-the-theme-editor
 * - Added support for subsections
 * - Added simpler findInstance and removeInstance functions
 */


theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  // Register event listeners for section events
  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {

  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  // We are using subSections for dynamic non-homepage section blocks
  _onSectionLoad: function(evt, subSection, subSectionId) {

    // Check if we have a subSection or a Section
    var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

    // If no subSection or Section exists, stop running
    if (!container) {
      return;
    }

    // Register section
    this._createInstance(container);

    // Store subSection or Section ID as an instance
    var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

    // #? I don't understand this. Why is it loading subsections, if a
    // subsection doesn't exist?
    if (!subSection) {
      this._loadSubSections();
    }

    // Run JS only in case of the section being selected in the editor
    // before merchant clicks "Add"
    if (instance && typeof instance.onLoad === 'function') {
      instance.onLoad(evt);
    }
  },

  // Look for `data-subsection` attributes and load them
  _loadSubSections: function() {
    $('[data-subsection]').each(function(evt, el) {
      this._onSectionLoad(null, el, $(el).data('section-id'));
    }.bind(this));
  },

  _onSectionUnload: function(evt) {
    var instance = this._removeInstance(evt.detail.sectionId);

    if (instance && typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }
  },

  _onSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  // A simpler version of findInstance specific to sections
  _findInstance: function(id) {
    for (var i = 0; i < this.instances.length; i++) {
      if (this.instances[i].id === id) {
        return this.instances[i];
      }
    }
  },

  // A simpler version of removeInstance specific to sections
  _removeInstance: function(id) {
    var i = this.instances.length;
    var instance;

    while(i--) {
      if (this.instances[i].id === id) {
        instance = this.instances[i];
        this.instances.splice(i, 1);
        break;
      }
    }

    return instance;
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;
    var $sections = $('[data-section-type=' + type + ']');

    $sections.each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});










/*==============================================================================
  #SLATE Currency
==============================================================================*/

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();










/*==============================================================================
  #SLATE Image
==============================================================================*/

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 * #EDIT: Added default size of 620x to imageSize function
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   *
   * Added default size of 620x
   */
  function imageSize(src) {
    if (!src) {
      return '620x'; // default based on theme
    }

    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();










/*==============================================================================
  #SLATE Variants
==============================================================================*/

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 *
 * #EDIT: 
 * - Added _updateSKU function
 * - Added _updateVariantButtons function for linked options
 * - Updated _getVariantFromOptions code to be simpler
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {

      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {

        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};
        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);


      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var match = true;
        var options = variant.options

        selectedValues.forEach(function(option) {
          if (match) {
            match = (variant[option.index] === option.value);
          }
        });

        if (match) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateVariantButtons(variant);
      this.currentVariant = variant;
      this._updatePaymentButton(variant);

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
     if (this.currentVariant != undefined) {
  var currentVariantImage = this.currentVariant.featured_image || {};
}

//       if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
//         return;
//       }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
//       if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
//         return;
//       }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (this.currentVariant != undefined ) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },
    _updatePaymentButton: function(variant) {
        if (this.currentVariant != undefined) {
          const paymentButton = document.querySelector('.payment-button');

          if (paymentButton) {
            paymentButton.removeAttribute('class', 'visually-hidden');
           }
        } else {
          document.querySelector('.payment-button').setAttribute('class', 'visually-hidden');
        }
      },


    /**
     * CUSTOM EVENT. If using buttons for our variants and linked options,
     * trigger change when selecting another button variant
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantButtonChange
     */
    _updateVariantButtons: function(variant) {
      this.$container.trigger({
        type: 'variantButtonChange',
        variant: variant
      });
    },


    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();




















/*==============================================================================
  #CONFIG & UTILITIES
==============================================================================*/

/**
 * There is no accurate way of detecting a touch device using JS. Ideally, you
 * would wait for a users first iteraction and determine if it's a touch or
 * mouse move:
 * https://blogs.perficientdigital.com/2017/11/21/detecting-the-use-of-a-touch-screen/
 *
 * `ontouchstart` is used by Modernizer:
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js#L40
 * 
 * `DocumentTouch`: very old and obsolete API since Gecko 25 (Firefox 25). Also
 * used by Modernizr.
 * https://developer.mozilla.org/en-US/docs/Web/API/DocumentTouch
 *
 * `maxTouchPoints`: returns number of touch contact points connected to the
 * device. Might not be best idea? Supported by Chrome Android, but not iOS.
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/maxTouchPoints
 *
 * `msMaxTouchPoints`: Only works for IE10. Future IEs removed this and used
 * standard `maxTouchPoints`:
 * https://technet.microsoft.com/en-us/windows/hh772144(v=vs.60)
 *
 * `matchMedia`: Similar to Prestige theme. matchMedia support is here:
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 *
 * `moz-touch-events` no longer available to web content since Firefox 58:
 * https://developer.mozilla.org/en-US/docs/Web/CSS/@media/-moz-touch-enabled
 *
 * `isIpad` uses the JS test method to check if the userAgent matches the
 * string of `ipad`. Read negative things about userAgent detection but mainly
 * from long time ago. This iPad setting was used on Impulse theme to add a
 * 'js-ipad' class to body and change some background attachments to initial.
 * We won't need it.
 */


theme.config = {
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false || window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches,
  mq: 'initial',
  bpMediumDown: false
};


theme.mq = {
  small: 'screen and (max-width: 767px)',
  medium: 'screen and (min-width: 768px) and (max-width: 1024px)',
  mediumDown: 'screen and (max-width: 1024px)',
  largeUp: 'screen and (min-width: 1025px)',
  large: 'screen and (min-width: 1025px) and (max-width: 1600px)',
  widesceen: 'screen and (min-width: 1601px)'
};


theme.setBreakpoints = function() {
  enquire.register(theme.mq.mediumDown, {
    match: function() {
      theme.config.bpMediumDown = true;
    },

    unmatch: function() {
      theme.config.bpMediumDown = false;
    }
  });
}










/*==============================================================================
  #Cart
  - Ajax Shopify API Utilities
==============================================================================*/

theme.CartUtilities = {
  getCart: function() {
    return $.getJSON('/cart.js');
  },

  changeItem: function(key, qty) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + key,
      dataType: 'json'
    });
  },

  addItemFromForm: function(data) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    });
  },

  _updateCart: function(params) {
    return $.ajax(params)
      .then(function(cart) {
        return cart;
      }.bind(this))
  },

  updateNote: function(note) {
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + theme.CartUtilities.attributeToString(note),
      dataType: 'json',
      success: function(cart) {},
      error: function(XMLHttpRequest, textStatus) {}
    };

    $.ajax(params);
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return $.trim(attribute);
  }
}










/*==============================================================================
  #AjaxProduct
==============================================================================*/

theme.AjaxProduct = (function() {
  var status = {
    loading: false
  };

  function ProductForm($form) {
    this.$form = $form;
    this.$addToCart = this.$form.find('.js-add-to-cart');

    if (this.$form.length) {
      this.$form.on('submit', this.addItemFromForm.bind(this));
    }
  };

  ProductForm.prototype = $.extend({}, ProductForm.prototype, {
    addItemFromForm: function(evt, callback){
      evt.preventDefault();

      if (status.loading) {
        return;
      }

      // Loading indicator on add to cart button
      this.$addToCart.addClass('btn--loading');

      status.loading = true;

      var data = this.$form.serialize();

      theme.CartUtilities.addItemFromForm(data)
        .then(function(product) {
          this.success(product);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.error(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          status.loading = false;
          this.$addToCart.removeClass('btn--loading');
        }.bind(this));
    },

    success: function(product) {
      this.$form.find('.alert--error').remove();
      $('body').trigger('added.ajaxProduct');
    },

    error: function(XMLHttpRequest) {
      this.$form.find('.alert--error').remove();

      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);

        this.$addToCart.after('<div class="alert  alert--error  alert--spacing">' + XMLHttpRequest.responseJSON.description + '</div>');
      }
    }
  });

  return ProductForm;
})();










/*==============================================================================
  # Theme Load Image Section
  - Allows for adding classes whilst loading so we can animate
==============================================================================*/

theme.loadImageSection = function($container) {
  // Wait until images inside container have lazyloaded class
  function setAsLoaded() {
    $container.removeClass('loading loading--delayed').addClass('loaded');
  }

  function checkForLazyloadedImage() {
    return $container.find('.lazyloaded').length;
  }

  // If it has SVGs it's in the onboarding state so set as loaded
  if ($container.find('svg').length) {
    setAsLoaded();
    return;
  };

  if (checkForLazyloadedImage() > 0) {
    setAsLoaded();
    return;
  }

  var interval = setInterval(function() {
    if (checkForLazyloadedImage() > 0) {
      clearInterval(interval);
      setAsLoaded();
    }
  }, 80);
};





















/*==============================================================================
  #MODULES
==============================================================================*/

/*==============================================================================
  #HeaderNav
  - This is a click-based header nav module. We're no longer using this.
==============================================================================*/

theme.HeaderNav = (function() {
  var selectors = {
    body: 'body',
    header: '.header',
    itemHasDropdown: '.header-nav__item--main--has-dropdown',
    mainLinks: '.header-nav__link--main',
    childLinks: '.header-nav__link--child',
    grandchildLinks: '.header-nav__link--grandchild',
    closeBtn: '.mega-menu__close',

    activeDropdown: '.header-nav__item--main--dropdown-is-open',
    dropdown: '.mega-menu'
  };


  var cache = {};


  var config = {
    activeDropdown: 'header-nav__item--main--dropdown-is-open',
    childLinks: 'header-nav__link--child',
    grandchildLinks: 'header-nav__link--grandchild',
    namespace: '.dropdown',
    transparentHeader: 'header--transparent',
    hasTransparentHeader: false
  }

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $body: $(selectors.body),
      $header: $(selectors.header),
      $itemHasDropdown: $(selectors.itemHasDropdown),
      $mainLinks: $(selectors.mainLinks),
      $childLinks: $(selectors.childLinks),
      $grandchildLinks: $(selectors.grandchildLinks),
      $closeBtn: $(selectors.closeBtn),
      $dropdown: $(selectors.dropdown)
    };
  }


  function init() {
    // Make our cached objects available
    cacheSelectors();

    // Initialise ARIA attributes
    cache.$itemHasDropdown.find(selectors.mainLinks).attr({
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    });

    if (cache.$header.hasClass(config.transparentHeader)) {
      config.hasTransparentHeader = true;
    }


    /**
     * 1. Dropdown click event handler 
     * The event handlers uses `evt.preventDefault()` to stop a link from 
     * firing, and allowing us to open or click a dropdown. This means that 
     * child links in our dropdown are also prevented from firing.
     */
    cache.$itemHasDropdown.on('click.' + config.namespace, toggleDropdown); /* [1] */

    /**
     * 2. Child and Grandchild Dropdown Links click event handler
     * Provides correct link behaviour to our child dropdown links. Our dropdown
     * click event handler prevents default link behaviour which also stops
     * our child dropdown links from firing. We use evt.stopPropagation on our 
     * child dropdown links to ensure they keep correct link behaviour.
     */
    cache.$childLinks.on('click' + config.namespace, function(evt) { /* [2] */
      evt.stopPropagation();
    });

    cache.$grandchildLinks.on('click' + config.namespace, function(evt) { /* [2] */
      evt.stopPropagation();
    });
  };



  /**
   * toggleDropdown function is bound to our dropdown click event handler, so
   * we pass in evt to our function.
   */

  function toggleDropdown(evt) {

    // `this` will refer to the dropdown we have clicked on. We wrap `this` in a
    // jQuery object.
    var $this = $(this);

    /**
     * 1. Prevent default link behaviour. This allows the dropdown to open or close
     * rather than the link click being fired and being sent to another page.
     * 
     * 2. We have a click event handler on our body that closes dropdowns. 
     * We need to stop immediate propagation so the click event doesn't bubble 
     * up to body level and close the dropdown straight after it is revealed,
     * and no other event handlers on the element or parent are fired that
     * interfere.
     */
    evt.preventDefault(); /* [1] */
    evt.stopImmediatePropagation(); /* [2] */

    /**
     * If dropdown is open, we close the dropdown. Else we open it. We pass in
     * `$this` which is our dropdown into our open or close functions.
     */
    if ($this.hasClass(config.activeDropdown)) {
      closeDropdown($this);
    } else {
      openDropdown($this);
    }
  };



  /**
   * Open Dropdown function. We take a parameter which is the active dropdown
   */
  function openDropdown($this) {
    /**
     * If an active dropdown is open, close it before opening another dropdown.
     * We do not use a cached selector such as $activeDropdown because that 
     * does not get updated when the DOM changes.
     */
    if ($(selectors.activeDropdown).length) {
      closeDropdown($(selectors.activeDropdown));
    }

    $('.header').addClass('header--dropdown-is-open');

    // Show dropdown by adding class that will display dropdown
    $this.addClass(config.activeDropdown);

    // ARIA set expanded to true
    $this.find(selectors.mainLinks).attr(
      {
        'aria-expanded': 'true'
      }
    );

    if ($this.hasClass('header-nav__item--search')) {
      // setTimeout("$('.header-search__input').focus();", 500);
    }

    /**
     * Attach event handlers to close the dropdown. These event handlers should
     * only fire when a dropdown is open.
     */

    // Close dropdown on click of body
    cache.$body.on('click' + config.namespace, function(evt) {
      closeDropdown($this);
    });

    cache.$closeBtn.on('click' + config.namespace, function(evt) {
      closeDropdown($this);
    });

    // Ensure click in dropdown does not close dropdown
    cache.$dropdown.on('click' + config.namespace, function(evt) {
      evt.stopImmediatePropagation();
    });

    // Close dropdown on keypress of escape
    cache.$window.on('keyup' + config.namespace, function(evt) { /* [2] */
      if (evt.which === 27) {
        closeDropdown($this);
      }
    });
  };



  /**
   * Close Dropdown function. We take a parameter which is the active dropdown
   */
  function closeDropdown($this) {
    $('.header').removeClass('header--dropdown-is-open');

    // Hide dropdown by removing class in CSS, so dropdown will display:none
    $this.removeClass(config.activeDropdown);

    // ARIA set expanded to false
    $this.find(selectors.mainLinks).attr(
      {
        'aria-expanded': 'false'
      }
    );

    /**
     * Detach event handlers to close dropdown. These event handlers were
     * attached when the dropdown is open, but not needed when closed.
     */
    cache.$body.off('click' + config.namespace);
    cache.$closeBtn.off('click' + config.namespace);
    cache.$window.off('keyup' + config.namespace);

  };



  /**
   * Revealing module pattern, we expose a specific part of our module to the
   * global scope.
   */

  return {
    init: init,
    closeDropdown: closeDropdown
  };
})(); /* end theme.HeaderNav */










/*==============================================================================
  #HeaderNavHover
  - This is a hover-based header nav module currently being used.
==============================================================================*/

theme.HeaderNavHover = (function() {
  var selectors = {
    body: 'body',
    header: '.header',
    desktopNav: '.desktop-navigation',
    itemHasDropdown: '.header-nav__item--main--has-dropdown',
    mainLinks: '.header-nav__link--main',
    childLinks: '.header-nav__link--child',
    grandchildLinks: '.header-nav__link--grandchild',
    closeBtn: '.mega-menu__close',

    activeDropdown: '.header-nav__item--main--dropdown-is-open',
    dropdown: '.mega-menu'
  };

  var self = this;

  var cache = {};


  var config = {
    activeDropdown: 'header-nav__item--main--dropdown-is-open',
    childLinks: 'header-nav__link--child',
    grandchildLinks: 'header-nav__link--grandchild',
    namespace: '.dropdown',
    transparentHeader: 'header--transparent',
    hasTransparentHeader: false,
    openingTimeout: null,
    currentMegaMenu: null
  }

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $body: $(selectors.body),
      $header: $(selectors.header),
      $desktopNav: $(selectors.desktopNav),
      $itemHasDropdown: $(selectors.itemHasDropdown),
      $mainLinks: $(selectors.mainLinks),
      $childLinks: $(selectors.childLinks),
      $grandchildLinks: $(selectors.grandchildLinks),
      $closeBtn: $(selectors.closeBtn),
      $dropdown: $(selectors.dropdown)
    };
  }


  function init() {
    // Make our cached objects available
    cacheSelectors();

    // Event delegation pattern for mouseenter
    cache.$desktopNav.on('mouseenter', '.header-nav__item--main--has-dropdown', function(event) {
      var $target = $(event.currentTarget);

      /**
       * BUG FIX 07 DEC 2022: 
       * We used to have an additional condition of:
       * `&& event.relatedTarget !== null` but this was causing issues on touch
       * devices. We've removed this and it's working well.
       */
      if ($target.length) {
        openDropdown($target);
      }

    });
  };

  function openDropdown(parentElement) {
    var $menuItem = parentElement.find("[aria-controls]");
    var $dropdown = parentElement.find(".mega-menu");

    var openingTimeout = setTimeout(() => {
      if ($menuItem.attr("aria-expanded") === "true") {
        return;
      }

      $('.header').addClass('header--dropdown-is-open');
      $menuItem.attr("aria-expanded", "true");
      parentElement.addClass(config.activeDropdown);

      const leaveListener = (event) => {
        /**
         * BUG FIX 07 DEC 2022: 
         * We used to have a condition of:
         * if (event.relatedTarget !== null)` but this was causing issues on touch
         * devices. We've removed this and it's working well.
         */
        closeDropdown(parentElement);
        parentElement.off("mouseleave");
      };

      parentElement.on("mouseleave", leaveListener);
      openingTimeout = null;

    }, 100);

    parentElement.on("mouseleave", () => {
      if (openingTimeout) {
        clearTimeout(openingTimeout);
      }
    });
  }

  function closeDropdown(parentElement) {
    var $menuItem = parentElement.find("[aria-controls]");
    var $dropdown = parentElement.find(".mega-menu");

    requestAnimationFrame(() => {
      $('.header').removeClass('header--dropdown-is-open');
      $menuItem.attr("aria-expanded", "false");
      parentElement.removeClass(config.activeDropdown);

      setTimeout(() => {
        clearTimeout(config.openingTimeout);
      }, 0);
    });
  }

  return {
    init: init
  }

})(); /* end theme.HeaderNavHover */








/*==============================================================================
  #Modals
==============================================================================*/

theme.Modals = (function() {

  var selectors = {
    activeModal: '.modal--is-visible',
    openModal: '.js-open-modal',
    closeModal: '.js-close-modal',
    modalContent: '.modal__content'
  };

  var config = {
    activeModal: 'modal--is-visible',
    namespace: '.modal'
  }

  var $activeModal = $(selectors.activeModal);
  var modalIsOpen;
  var $html = $('html');

  if ($activeModal.length) {
    modalIsOpen = true;
  }

  function init() {
    $(selectors.openModal).on('click' + config.namespace, openModal);
    $(selectors.closeModal).on('click' + config.namespace, closeModal);
  }

  function openModal(evt) {

    if (evt) {
      evt.preventDefault();
    }

    // Make sure no other modal is already open. If so, close it.
    if (modalIsOpen) {
      closeModal();
    }

    // Get Modal by ID tag. The aria-controls of the open button will match the ID of the modal.
    var $target = $(evt.currentTarget)
    var targetId = $target.attr('aria-controls');
    var $modal = $('#' + targetId);

    // Add active modal class
    $modal.addClass(config.activeModal);

    // Change aria-hidden
    $modal.attr('aria-hidden', 'false');

    // Add no scroll class to html
    $html.addClass('no-scroll');

    // Set $activeModal to the opened modal
    $activeModal = $modal;
    modalIsOpen = true;

    // Bind events
    bindEvents();
  }


  function closeModal(evt) {

    // Check that a modal is open. If not, return.
    if (!modalIsOpen) {
      return;
    }

    // Remove active class
    $activeModal.removeClass(config.activeModal);

    // Change aria-hidden
    $activeModal.attr('aria-hidden', 'true');

    // Remove no scroll class to html
    $html.removeClass('no-scroll');

    // Set $activeModal to false
    modalIsOpen = false;

    // Unbind Events
    unbindEvents();
  }


  function bindEvents() {

    // Close modal on ESC
    $(document).on('keyup' + config.namespace, function(evt) {
      if (evt.keyCode === 27) {
        closeModal();
      }
    })

    // Clicking outside of modal will close it
    $activeModal.on('click' + config.namespace, function(evt) {
      closeModal();
    });

    // However, we don't want it closed when clicking on modal content.
    $(selectors.modalContent).on('click' + config.namespace, function(evt) {
      evt.stopImmediatePropagation();
    });
  }


  function unbindEvents() {

    // Remove escape keyup event
    $(document).off('keyup' + config.namespace);

    // Remove $activeModal click
    if ($activeModal) {
      $activeModal.off('click' + config.namespace);
    }

    // Remove modalContent click
    $(selectors.modalContent).off('click' + config.namespace);
  }

  return {
    init: init
  }

})();










/*==============================================================================
  #Popovers
==============================================================================*/

theme.Popovers = (function() {

  var selectors = {
    activePopover: '.popover--is-active',
    openPopover: '.js-open-popover',
    closePopover: '.js-close-popover'
  };

  var config = {
    activePopover: 'popover--is-active',
    namespace: '.popover'
  };

  var $activePopover = $(selectors.activePopover);
  var popoverIsOpen;
  var $html = $('html');


  if ($activePopover.length) {
    popoverIsOpen = true;
  }


  function init() {
    $(selectors.openPopover).on('click' + config.namespace, openPopover);
  };


  function openPopover(evt) {

    // In case it's a link, prevent default behaviour
    if(evt) {
      evt.preventDefault();
    }

    // We close popovers on click outside of popover. We need to stop
    // propagation so it doesn't bubble up and close the popover.
    evt.stopPropagation();

    // var activeDropdown = $(".header-nav__item--main--dropdown-is-open");

    // if (activeDropdown.length) {
    //   theme.HeaderNav.closeDropdown(activeDropdown); /* [3] */
    // }

    if(popoverIsOpen) {
      closePopover();
    }

    var $target = $(evt.currentTarget);
    var targetId = $target.attr('aria-controls');
    var $popover = $('#' + targetId);

    $popover.addClass(config.activePopover);
    $popover.attr('aria-hidden', 'false');

    $activePopover = $popover;
    popoverIsOpen = true;

    bindEvents();
  };


  function closePopover(evt) {
    if (!popoverIsOpen) {
      return;
    }

    $activePopover.removeClass(config.activePopover);

    $activePopover.attr('aria-hidden', 'true');

    popoverIsOpen = false;

    unbindEvents();
  };


  function bindEvents() {

    $(document).on('keyup' + config.namespace, function(evt) {
      if (evt.keyCode === 27) {
        closePopup();
      }
    });


    $('html').on('click' + config.namespace, function(evt) {
      closePopover();
    });

    $(selectors.activePopover).on('click' + config.namespace, function(evt) {
      evt.stopImmediatePropagation();
    });
  };


  function unbindEvents() {
    $(document).off('keyup' + config.namespace);

    $('html').off('click' + config.namespace);

    $(selectors.activePopover).off('click' + config.namespace);
  };


  return {
    init: init
  };

})();










/*==============================================================================
  #Drawers

   - Largely based off Shopify Timber Drawers, with inspiration from Pushy JS,
      and Drawer.js
    
    WHAT IT DOES:
    - This allows us to create multiple off-canvas drawers
    - We use a constructor function and create an instance for each drawer we
      would like
    - We use prototypes to add methods to our constructor that can be shared
      amongst all our drawer instances
    - Due to using prototypes, we must use `this.[property]` to expose variables
      to our prototype methods.

    HOW TO USE:
    - Create an instance of a drawer such as:

    var drawerVariableName = new Drawer(drawerId, drawerName)
==============================================================================*/

theme.Drawers = (function() {

  function Drawer(drawerId, drawerName) {

    this.id = drawerId;
    this.name = drawerName;

    this.selectors = {
      html: document.documentElement,
      body: 'body',
      MainContent: '#MainContent',
      overlay: '.drawer-overlay',

      openBtn: '.js-drawer-open-' + drawerName,
      closeBtn: '.js-drawer-close'
    };

    this.cache = {
      $html: $(this.selectors.html),
      $body: $(this.selectors.body),
      $parent: $(this.selectors.html),
      $mainContent: $(this.selectors.mainContent),
      $overlay: $(this.selectors.overlay),

      $openBtn: $(this.selectors.openBtn),
      $closeBtn: $(this.selectors.closeBtn)
    };

    // Config object
    this.config = {
      open: 'js-drawer-is-open',
      noScroll: 'no-scroll',

      activeDrawer: 'drawer--is-open',
      activeOverlay: 'drawer-overlay--is-visible',

      namespace: '.drawer-' + name
    };

    // cache our drawer
    this.$drawer = $('#' + this.id);

    // Check if drawer exists
    if (!this.$drawer.length) {
      return false;
    }

    // Drawer flag to indicate if open or closed
    this.drawerIsOpen = false;

    // Last focus variable which will store the element that was focused prior
    // to opening the drawer
    this.$lastFocus = null;

    // Initialise our drawers
    this.init();
  };


  Drawer.prototype = $.extend({}, Drawer.prototype, {

    /* Drawer Init
     ======================================================================== */
    init: function() {
      var $openBtn = this.cache.$openBtn;

      // Attach aria-attributes on initialisation
      $openBtn.attr({
        'aria-controls': '#' + this.id,
        'aria-expanded': 'false'
      });

      /**
       * Open event handler. We use `.bind` to ensure that `this` refers to our 
       * Drawer object, not the jQuery object that is handling our event.
       */    
      $openBtn.on('click' + this.config.namespace, this.open.bind(this));
    },


    /* Drawer Open
     ======================================================================== */
    open: function(evt) {

      /**
       * When opening a drawer via a link we want to prevent the default 
       * behaviour of a link click event.
       *
       * When we open a drawer externally such as a Cart Drawer opening when 
       * an item is added to cart, `evt.preventDefault` encounters an error 
       * because there is no event, so evt is undefined.
       *
       * So, we use a conditional statement to check if our a drawer is opened
       * through an event/link click or externally.
       */
      if (evt) {
        evt.preventDefault();
      }

      // Defensive code to ensure that you can't open an already opened drawer
      if (this.drawerIsOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer. Doesn't cause issues for me.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();

        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }

      // var activeDropdown = $(".header-nav__item--main--dropdown-is-open");

      // if (activeDropdown.length) {
      //   theme.HeaderNav.closeDropdown(activeDropdown); /* [3] */
      // }


      // Store our last focused element before opening the drawer as jQuery object
      this.$lastFocus = $(document.activeElement);

      // Show drawer
      this.$drawer.addClass(this.config.activeDrawer);

      // Add noScroll class to html/body
      if (this.name != 'dropdown') {
        this.cache.$parent.addClass(this.config.noScroll);
      }

      this.cache.$overlay.addClass(this.config.activeOverlay);

      // Set active flag to true
      this.drawerIsOpen = true;

      // Trap focus to drawer
      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      // Having this trigger, will allow us to close any modals/other elements
      // that may affect the drawer. An example is if we use a quickview modal
      // and add to cart, we want to close the modal, and open the cart drawer.
      $('body').trigger('drawerOpen.' + this.id);

      // Aria-expanded to true
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      // Bind close drawer event handlers
      this.bindEvents();
    },


    /* Drawer Close
     ======================================================================== */
    close: function() {

      // Defensive code to ensure you can't close a closed drawer
      if (!this.drawerIsOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      // Close drawer
      this.$drawer.removeClass(this.config.activeDrawer);

      // Remove noScroll
      if (this.name != 'dropdown') {
        this.cache.$parent.removeClass(this.config.noScroll);
      }

      this.cache.$overlay.removeClass(this.config.activeOverlay);

      // Set flag to false
      this.drawerIsOpen = false;

      // Remove focus
      slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      // Aria-expanded to false
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false');
      }

      // Return focus to the element prior to opening our drawer    
      if (this.$lastFocus !== null) {
        this.$lastFocus.focus();     
      }

      // Unbind close drawer event handlers
      this.unbindEvents();
    },



    /* Drawer Bind Events
    ========================================================================= */
    bindEvents: function() {

      // Close on click of close button
      this.cache.$closeBtn.on('click' + this.config.namespace, this.close.bind(this));

      // Close on click of overlay
      this.cache.$overlay.on('click' + this.config.namespace, function (evt) {
          this.close();
      }.bind(this));

      // Close on keypress of escape key
      this.cache.$parent.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
    },


    /* Drawer Unbind Events
    ========================================================================= */
    unbindEvents: function() {
      this.cache.$parent.off(this.config.namespace);
      this.cache.$overlay.off(this.config.namespace);
      this.cache.$closeBtn.off(this.config.namespace);
    }

  });

  return Drawer;
})();










/*==============================================================================
  #Slidesow

    Slideshow module that can be used across the site. When requiring a new
    slideshow (product page, homepage section, etc) we can call this function
    and pass in the element we want as our slideshow. Based loosely on Impulse
    and Debut Shopify themes.
   
    DEPENDENCIES:
    - Slick Slider (stored in our vendor.js)
    - jQuery
==============================================================================*/

theme.Slideshow = (function() {

  // By default this is null, until we pass in a slideshow
  this.$slideshow = null;

  // Store our selectors
  var selectors = {
    slideshowWrapper: '.slideshow-wrapper',
    slideshow: '.slideshow',
    next: '.is-next',
    init: '.is-init',
    animateOut: '.animate-out',
    allSlides: '.slick-slide',
    currentSlide: '.slick-current',
    pauseButton: '.slideshow__pause',
    isPaused: '.is-paused'
  };


  // Store our classes / config
  var classes = {
    slideshowWrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    next: 'is-next',
    init: 'is-init',
    animateOut: 'animate-out',
    allSlides: 'slick-slide',
    currentSlide: 'slick-current',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  }


  // We pass in the slideshow (el) and it's settings (args)
  function slideshow(el, args) {

    // Store our variables as jQuery
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest(selectors.slideshowWrapper);

    // this.$pause = this.$wrapper.find(selectors.pauseButton); 


    /**
     * Settings object for the slideshow. Slick options here:
     * https://github.com/kenwheeler/slick#settings
     */
    this.settings = {
      accessibility: true,
      arrows: args.arrows ? true : false,
      dots: args.dots ? true : false,
      autoplay: args.autoplay ? true : false,
      autoplaySpeed: args.autoplaySpeed ? args.autoplaySpeed : false,
      rows: 0,
      prevArrow: args.prevArrow ? args.prevArrow : false,
      nextArrow: args.nextArrow ? args.nextArrow : false
    };

    this.mobileSettings = {
      accessibility: true,
      arrows: args.arrows ? true : false,
      dots: args.dots ? true : false,
      autoplay: args.autoplay ? true : false,
      autoplaySpeed: args.autoplaySpeed ? args.autoplaySpeed : false,
      rows: 0,
      prevArrow: args.prevArrow ? args.prevArrow : false,
      nextArrow: args.nextArrow ? args.nextArrow : false,
      slidesToShow: 2
    }


    /**
     * Event Handlers
     * https://github.com/kenwheeler/slick#events
     */
    this.$slideshow.off('beforeChange');
    this.$slideshow.off('afterSlideChange');

    // Init must be called before initializing the slider
    this.$slideshow.on('init', this.init.bind(this));
    this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
    this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));

    /**
     * Initialise slick on our slideshow
     */
    this.$slideshow.slick(this.settings);

    // this.$pause.on('click', this._togglePause.bind(this));
  }


  slideshow.prototype = $.extend({}, slideshow.prototype, {

    init: function(event, obj) {
      this.$slideshowList = obj.$list;
      this.$slickDots = obj.$dots;
      this.$allSlides = obj.$slides;
      this.slideCount = obj.slideCount;

      // Add an init class to slideshow
      this.$slideshow.addClass(classes.init);

      // Run function for accessibility features
      this._a11y();

      /**
       * Slick Slider clones slides when using infinite mode. We want to ensure
       * these cloned slides are lazy loaded.
       */ 
      this._clonedLazyloading();
    },


    // Use this to add an animation on slide change
    beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find(selectors.currentSlide).addClass(classes.animateOut);
    },


    // Use this to remove an animation on slide change
    afterSlideChange: function(event, slick, currentSlide) {
      var $slider = slick.$slider;
      var $allSlides = $slider.find(selectors.allSlides).removeClass(classes.animateOut);
    },


    // Destroy slideshow function
    destroy: function() {
      this.$slideshow.slick('unslick');
    },


    /**
     * Playback and Pause functions
     * Primarily used for keyboard accessibility
     */
    _play: function() {
      this.$slideshow.slick('slickPause');
      $(selectors.pauseButton).addClass(classes.isPaused);
    },

    _pause: function() {
      this.$slideshow.slick('slickPlay');
      $(selectors.pauseButton).removeClass(classes.isPaused);
    },

    _togglePause: function() {
      var slideshowSelector = this._getSlideshowId(this.$pause);
      if (this.$pause.hasClass(classes.isPaused)) {
        this.$pause.removeClass(classes.isPaused);
        $(slideshowSelector).slick('slickPlay');
      } else {
        this.$pause.addClass(classes.isPaused);
        $(slideshowSelector).slick('slickPause');
      }
    },


    /**
     * Helper functions
     */
    _getSlideshowId: function($el) {
      return '#Slideshow-' + $el.data('id');
    },

    _activeSlide: function() {
      return this.$slideshow.find('.slick-active');
    },

    _currentSlide: function() {
      return this.$slideshow.find('.slick-current');
    },

    _nextSlide: function(index) {
      return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
    },



    /**
     * A11Y Accessibility Function
     */
    _a11y: function() {
      var $list = this.$slideshowList;
      var autoplay = this.settings.autoplay;

      // Defensive code to check that slideshow exists
      if (!$list) {
        return;
      }

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');


      /**
       * When an element in the slider is focused, pause the slideshow and set
       * aria-live. This is needed only if autoplay is enabled.
       */
      $(selectors.slideshowWrapper).on('focusin', function(evt) {
        if (!$(selectors.slideshowWrapper).has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');
        if (autoplay) {
          this._pause();
        }
      }.bind(this));


      /**
       * Resume autoplay when a slide is focused out
       */
      $(selectors.slideshowWrapper).on('focusout', function(evt) {
        if (!$(selectors.slideshowWrapper).has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');
        if (autoplay) {
          this._play();
        }
      }.bind(this));
    },




    /**
     * Cloned Lazy Loading
     * When using the infinite setting on Slick Slider, we get cloned slides.
     * We ensure that lazyloading works on cloned slides.
     */

    _clonedLazyloading: function() {
      var $slideshow = this.$slideshow;

      $slideshow.find('.slick-slide').each(function(index, el) {
        var $slide = $(el);

        if ($slide.hasClass('slick-cloned')) {

          // Get the slideId which is the block.id stored in a data attribute
          var slideId = $slide.data('id');
          var $slideImg = $slide.find('.slide__image').removeClass('lazyloading').addClass('lazyloaded');

          /**
           * Get inline style attribute from non-cloned slide with arbitrary 
           * timeout so the image is loaded
           */
          setTimeout(function() {
            var loadedImageStyle = $slideshow.find('.slide--' + slideId + ':not(.slick-cloned) .slide__image').attr('style');

            if (loadedImageStyle) {
              $slideImg.attr('style', loadedImageStyle);
            }

          }, this.settings.autoplaySpeed / 1.5);

        }
      }.bind(this));
    }

  });

  return slideshow;
})();










/*==============================================================================
  #Collapsibles
==============================================================================*/

/**
 * For smooth collapsibles we need to use height transitions. This is not 
 * supported in CSS, so we have to use JS.
 * https://css-tricks.com/using-css-transitions-auto-dimensions/#article-header-id-3
 */

theme.Collapsibles = (function() {

  var selectors = {
    keepMultipleOpen: '[data-keep-multiple-collapsibles-open]',
    collapsible: '.collapsible',
    button: '.collapsible__heading',
    panel: '.collapsible__panel',
    panelContent: '.collapsible__panel-content',
    activeCollapsible: '.collapsible--is-open'
  };

  var config = {
    activeCollapsible: 'collapsible--is-open',
    keepMultipleOpen: false
  }


  function init() {
    // Event handler on click
    $(selectors.button).on('click', function(evt) {

      // Get current event target which will be the collapsible button
      var $target = $(evt.currentTarget);

      // Get keepMultipleOpen selector if it exists
      var $keepMultipleOpen = $target.closest(selectors.keepMultipleOpen);

      /**
       * If we have a data-keep-multiple-collapsibles-open attribute on the
       * collapsible wrapper, we set the flag to true.
       */

      if ($keepMultipleOpen.length) {
        config.keepMultipleOpen = true;
      } else {
        config.keepMultipleOpen = false;
      }


      /**
       * If we have nested collapsibles, we ensure that click events don't bubble
       * so a nested collapsible doesn't open and then close.
       */
      evt.stopPropagation();

      // Pass our $target to toggleCollapsible function
      toggleCollapsible($target);
    });
  };



  // Pass in our $target element (the button that was clicked)
  function toggleCollapsible($target) {

    // Get the parent collapsible
    var $parentCollapsible = $target.closest(selectors.collapsible);

    // Get the collapsiblePanel
    var $collapsiblePanel = $parentCollapsible.find('> ' + selectors.panel);;


    /**
     * Check if the collapsible is open or closed and run the relevant function
     * passing in the parentCollapsible and collapsiblePanel
     */
    if ($parentCollapsible.hasClass(config.activeCollapsible)) {
      closeCollapsible($parentCollapsible, $collapsiblePanel);
    } else {
      openCollapsible($parentCollapsible, $collapsiblePanel);
    }


    /**
     * If we want only one collapsible open at a time, we run this function
     * to close sibling collapsibles
     */
    if (!config.keepMultipleOpen) {

      $parentCollapsible.siblings(selectors.collapsible).each(function(index, element) {

        // This stores all parentCollapsibles
        var $parent = $(element);

        // This stores all collapsiblePanels
        var $panel = $parent.find('> ' + selectors.panel);

        closeCollapsible($parent, $panel);
      });
    }
  };


  // Pass in the parent collapsible, and collapsible panel
  function openCollapsible($parentCollapsible, $collapsiblePanel) {

    // If already open, skip this function
    if ($parentCollapsible.hasClass(config.activeCollapsible)) {
      return;
    }

    /**
     * As we may have nested collapsibles, we need to ensure we get the direct
     * descendant toggleButton
     */
    var $toggleButton = $parentCollapsible.find('> ' + selectors.button);

    // Add aria expanded
    $toggleButton.attr('aria-expanded', true);


    // Get panel height
    var panelHeight = $collapsiblePanel.first().prop("scrollHeight");

    // We need to declare an explicit height before setting to auto
    $collapsiblePanel.css({
      'overflow': 'visible',
      'height' : panelHeight + 'px'
    });

    // On completion of CSS transition, we set height to auto
    var transitionEnded = function transitionEnded(evt) {
      if (evt.originalEvent.propertyName === 'height') {
        $collapsiblePanel.css('height', 'auto');
        $collapsiblePanel.off('transitionend');
      }
    };

    $collapsiblePanel.on('transitionend', transitionEnded);

    // Add active class. This needs to be placed last to not interfere with
    // CSS height changes
    $parentCollapsible.addClass(config.activeCollapsible);

  }


  function closeCollapsible($parentCollapsible, $collapsiblePanel) {

    // If already closed, skip this function
    if (!$parentCollapsible.hasClass(config.activeCollapsible)) {
      return;
    }

    /**
     * As we may have nested collapsibles, we need to ensure we get the direct
     * descendant toggleButton
     */
    var $toggleButton = $parentCollapsible.find('> ' + selectors.button);

    // Add aria expanded
    $toggleButton.attr('aria-expanded', false);

    var panelHeight = $collapsiblePanel.first().prop("scrollHeight");

    $collapsiblePanel.css({
      'overflow': 'hidden',
      'height' : panelHeight + 'px'
    });

    var offsetHeight = $collapsiblePanel.outerHeight();

    $collapsiblePanel.css({
      'height' : offsetHeight + 'px'
    });

    $collapsiblePanel.css({
      'height' : '0'
    });

    // Remove active class. This needs to be placed last to not interfere with
    // CSS height changes
    $parentCollapsible.removeClass(config.activeCollapsible);
  }


  return {
    init: init
  };
})();










/*==============================================================================
  #Tabs
==============================================================================*/

theme.Tabs = (function() {

  var config = {
    activeTab: 'tab--is-active'
  }

  function init() {
  }

  $('.tab').on('click', function(evt) {

    var $this = $(this);

    if ($this.hasClass(config.activeTab)) {
      return;
    }

    // Get Tab ID
    var tabId = $this.find('span').attr('id');

    /**
     * As we may have multiple tab components, we make heavy use of the parent()
     * selector. This ensures one tab component doesn't affect another.
     */
    // Remove active class and ARIA
    $this.parent().find('.tab').removeClass(config.activeTab);
    $this.parent().parent().find('.tab__panel').removeClass(config.activeTab).attr('aria-hidden', 'true');
    $this.parent().find('.tab > [aria-selected="true"]').attr('aria-selected', 'false');

    // Add active classes and ARIA
    $this.addClass(config.activeTab);
    $this.parent().parent().find('[aria-labelledby="tab-' + tabId + '"]').addClass(config.activeTab).attr('aria-hidden', 'false');
  });

  return {
    init: init
  }
})();










/*==============================================================================
  #AJAX Newsletter Form - Mailchimp
==============================================================================*/

theme.ajaxNewsletterForm = function() {

  // Set variables for footer and popup classes
  var $newsletterPage = $('.js-newsletter-page');

  var $newsletterPageResponse = $('.js-newsletter-page-response');

  // Our submit event listener for a specific form
  function ajaxMailChimpForm($form, $responseElement) {
    $form.submit(function(evt){
      evt.preventDefault();
      submitForm($form, $responseElement);
    });
  }


  // Submit form event handler
  function submitForm($form, $responseElement) {
    $.ajax({
      type: "GET",
      url: $form.attr("action"),
      data: $form.serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",

      error: function(error) {
        // According to jquery docs, this is never called for cross-domain JSONP requests
        alert("Could not connect to the server. Please try again later.");
      },

      success: function(data) {
        var successMessage = $('.newsletter-response').attr('data-newsletter-success');
        var alreadySubscribedMessage = $('.newsletter-response').attr('data-newsletter-already-subscribed');

        if (data.result != "success") {

          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            $responseElement.removeClass('newsletter-alert--success').addClass('newsletter-alert--error');
            $responseElement.html(alreadySubscribedMessage).show();
            setSubscribedCookie();

          } else {
            $responseElement.removeClass('newsletter-alert--success').addClass('newsletter-alert--error');
            $responseElement.html(data.msg).show();
          }

        } else {
          $responseElement.removeClass('newsletter-alert--error').addClass('newsletter-alert--success');
          $responseElement.html(successMessage).show();
        }
      }
    });
  }

  // Run the code for each newsletter form on your page
  ajaxMailChimpForm($newsletterPage, $newsletterPageResponse);
}


















/*==============================================================================
  #SECTIONS
==============================================================================*/


/*==============================================================================
  #HeaderSection
==============================================================================*/

theme.HeaderSection = (function() {

  function Header(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var selectors = this.selectors = {
      header: '.header'
    };

    var cache = this.cache = {
      $header: $(this.selectors.header),
      $headerSearch: $('.header-search'),
      $openSearch: $('.js-open-search'),
      $closeSearch: $('.js-close-search')
    };

    var config = this.config = {
      headerHasScrolled: 'header--has-scrolled',
      headerNamespace: '.header',
      searchIsOpen: 'header-search--is-open'
    };


    // Header scroll variables
    var prevScrollPos = 0;
    var hasScrolledUp = false;

    theme.HeaderNavHover.init();
    this.initDrawers();
    this.initHeaderSearch();

    stickybits('.shopify-section--header');

    /**
     * Scroll event listener for header.
     * Use a throttle of 16 that matches 60fps.
     */
    $(window).on('scroll' + config.headerNamespace, $.throttle(16, onScroll).bind(this));

    /**
     * Scroll event handler. On scroll down, we hide the header. On scroll up,
     * we show the header.
     */
    function onScroll() {
      // var headerHeight = 150;
      var scrollPos = window.scrollY;
      var scrollThreshold = 10;

      if (scrollPos > scrollThreshold) {
        cache.$header.addClass(config.headerHasScrolled);
        // hasScrolledUp = scrollPos > headerHeight;
      // When we scroll down, we hide the header
      } else {
        cache.$header.removeClass(config.headerHasScrolled);
      }

      prevScrollPos = scrollPos;
    }


    $('[data-collection-image]').on('mouseover', function(evt) {
      var $this = $(this);
      var index = $(this).attr('data-mega-menu-index');
      var link = $(this).attr('href');
      var image = $this.attr('data-collection-image');

      $('.js-dropdown-image-' + index + '').attr('src', image);
      $('.js-dropdown-image-link-' + index + '').attr('href', link);
    });
  }


  Header.prototype = $.extend({}, Header.prototype, {

    initDrawers: function() {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
      theme.DropdownDrawer = new theme.Drawers('DropdownDrawer', 'dropdown');

      if (theme.settings.cartType === 'drawer') {
        theme.CartDrawer = new theme.Drawers('CartDrawer', 'cart');
      }
    },

    initHeaderSearch: function() {
      var self = this;

      this.cache.$openSearch.on('click', this.toggleSearch.bind(this));
    },

    toggleSearch: function(evt) {
      evt.preventDefault();

      var self = this;

      if (this.cache.$headerSearch.hasClass(this.config.searchIsOpen)) {
        self.closeSearch();
      } else {
        self.openSearch();
      }
    },

    openSearch: function(evt) {
      var self = this;

      self.cache.$headerSearch.addClass(self.config.searchIsOpen);
      self.cache.$closeSearch.on('click.headerSearch', this.closeSearch.bind(this));
      setTimeout("$('.header-search__input').focus();", 300);
    },

    closeSearch: function(evt) {
      var self = this;

      self.cache.$headerSearch.removeClass(self.config.searchIsOpen);
      self.cache.$closeSearch.off('click.headerSearch');
    },

    /**
     * Shopify Theme Editor events
     */

    onSelect: function() {
      theme.HeaderNavTouch.init();
    }

  });

  return Header;

})();










/*==============================================================================
  #DrawerMenuSection
  - Our Drawer Menu is registered as a section hence a separate JS section
    module. Majority of functions here ensure the drawer works smoothly in
    the Theme Editor.
==============================================================================*/

theme.DrawerMenuSection = (function() {

  function DrawerMenuSection(container) {
    this.init();
  }

  DrawerMenuSection.prototype = $.extend({}, DrawerMenuSection.prototype, {


    init: function() {
      this.onUnload();

      theme.DrawerMenu = new theme.Drawers('NavDrawer', 'nav');
    },

    /**
     * Shopify Theme Editor events
     */

    forceReload: function() {
      this.init();
    },

    onSelect: function() {
      theme.DrawerMenu.open();
      // theme.Collapsibles.init();
    },

    onDeselect: function() {
      theme.DrawerMenu.close();
    },

    onUnload: function() {
      if (theme.DrawerMenu) {
        theme.DrawerMenu.close();
      }
    }
  });

  return DrawerMenuSection;
})();










/*==============================================================================
  #Cart
  - This code handles major cart related functionality on both the cart page and
    the AJAX cart drawer.
==============================================================================*/


theme.Cart = (function() {

  var itemCount = window.theme.settings.cartCount;
  var loading = false;


  function init() {
    /**
     * On custom event `added.ajaxProduct` we run buildCart. This is triggered 
     * in `theme.ProductForm`. We don't place this in our initEventListeners()
     * function as we don't need to re-run this, as it's triggered elsewhere.
     *
     * The function will run the AJAX request to get our cart. We need to pass
     * this cart object in to our buildCart function.
     */
    $('body').on('added.ajaxProduct', function() {
      theme.CartUtilities.getCart().then(function(cart) {
        buildCart(cart);
      }.bind(this));
    }.bind(this));

    // Store cart note when AJAX cart changes
    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      theme.CartUtilities.updateNote(newNote);
    });
    
    initEventListeners();
  };


  function initEventListeners() {

    /**
     * Quantity related event listeners
     */
    $('.js-qty-increase').on('click', updateQuantity);
    $('.js-qty-decrease').on('click', updateQuantity);
    $('.js-qty-input').on('blur', updateQuantity);
  };


  function updateQuantity(evt) {

    // Prevent default link behaviour for remove link
    evt.preventDefault();

    // Store our target element
    var $target = $(evt.currentTarget);

    // Set quantity
    var parsedQuantity = 1;

    // Get variant ID
    var id = $target.attr('data-line-id');

    // If target is our input element
    if ($target.hasClass('js-qty-input')) {

      // Get the current value
      var currentValue = parseInt($target.attr('data-current-value'));

      // Get the new user-input value
      parsedQuantity = parseInt($target.val());

      // Check that new user-input value is a number. If not, default to the current value.
      if (!Number.isInteger(parsedQuantity)) {
        parsedQuantity = currentValue;
      }

      // Set the input element to our new user-input value or current value
      $target.val(parsedQuantity);

      // Return if current value is same as new value
      if (currentValue === parsedQuantity) {
        return;
      }
    } else {

      // Get new quantity if using the +/- increment buttons
      parsedQuantity = $target.attr('data-quantity');

      // Set our input as the new quantity
      $target.siblings('.js-qty-input').val(parsedQuantity);
    }

    // Run updateItem with our event, variant ID, and new quantity
    updateItem(evt, id, parsedQuantity);
  };


  function updateItem(evt, id, qty) {
    if (loading) {
      return;
    }

    loading = true;

    theme.CartUtilities.changeItem(id, qty)
      .then(function(cart) {
        updateSuccess(cart);
      }.bind(this))
      .catch(function(XMLHttpRequest) {
        updateError(XMLHttpRequest)
      }.bind(this))
      .always(function() {
        loading = false;
      }.bind(this));
  };


  function buildCart(cart) {

    loading = true;

    var cart = cart;
    var url = '';

    /**
     * Depending on whether we're on the cart template or outside of it, we pull
     * in a specific cart template. We're not using a templating library such as
     * Handlebars. This is a potentially more app-friendly solution as we can
     * re-run liquid. This solution is influenced by Maestrooo on their Prestige
     * and Warehouse themes.
     */
    if (window.theme.settings.template !== 'cart') {
      url = '/cart?view=drawer&timestamp=' + Date.now();
    } else {
      url = '/cart?timestamp=' + Date.now();
    }

    $.ajax(url, {
        method: 'GET',
        dataType: 'html'
      })
      .done(function(data, textStatus, jqXHR) {

        if (window.theme.settings.template !== 'cart' && window.theme.settings.cartType === 'drawer') {
          
          // Update Cart Drawer Items
          var tempElement = document.createElement('div');
          tempElement.innerHTML = data;

          var cartNodeParent = document.querySelector('.js-cart-content').parentNode;

          cartNodeParent.replaceChild(tempElement.querySelector('.js-cart-content'), document.querySelector('.js-cart-content'));

          theme.CartDrawer.open();

        } else {
          // We are forcing a location reload on the cart page to ensure we run
          // any necessary JS for 3rd party apps etc.
          window.location.reload();
        }

      })
      .fail(function() {
        console.log("error");
      })
      .always(function() {
        loading = false;
        initEventListeners();
      });


    if (cart.items.length > 0) {
      $('.header__cart-dot').addClass('header__cart-dot--is-visible');
    } else {
      $('.header__cart-dot').removeClass('header__cart-dot--is-visible');
    }
  };


  function updateSuccess(cart) {
    buildCart(cart);
  };


  function updateError(XMLHttpRequest) {
    if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
      console.warn(XMLHttpRequest.responseJSON.description);
    }
  };

  return {
    init: init
  };

})();










/*==============================================================================
  #Product
==============================================================================*/

theme.Product = (function() {

  var selectors = {
    currentSlide: '.slick-current',
    zoomImage: '.product__image--zoom'
  };

  var config = {
    zoomInit: 'product__image-slide--init-zoom',
    activeZoom: 'image-is-zoomed'
  };


  function Product(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    this.settings = {
      enableHistoryState: this.options['enableHistoryState'],
      namespace: '.product-' + sectionId,

      enableImageZoom: this.options['enableImageZoom'],
      showPaymentButton: this.options['showPaymentButton'],
      slickMainInitialized: false,
      hasImages: true,
      hasMultipleImages: false,
      imageSize: '620x'
    };


    this.selectors = {
      productJson: 'ProductJson-' + sectionId,

      productImageWrapper: '.js-product-image-wrapper-' + sectionId,
      productMainSlider: '.js-product-slider-' + sectionId,

      price: '.js-product-price-' + sectionId,
      comparePrice: '.js-product-compare-price-' + sectionId,

      addToCart: '.js-add-to-cart-' + sectionId,
      addToCartText: '.js-add-to-cart-text-' + sectionId,

      originalSelectorId: '.js-product-form-selector-master-' + sectionId,
      singleOptionSelector: '.js-product-form-selector-' + sectionId,
      singleOptionSelectorRadio: '.variant-button__input',

      formContainer: '.js-product-form-' + sectionId
    };


    // Check this is a product object
    if (!$('#' + this.selectors.productJson).html()) {
      return;
    }

    // Parse our product json object
    this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);


    // Cache slider and image variables
    this.$productMainSlider = $(this.selectors.productMainSlider);

    // We get our first product image
    this.$firstProductImage = this.$productMainSlider.find('img').first();

    // Defensive code to check if images exist
    if (!this.$firstProductImage.length) {
      this.settings.hasImages = false;
    }

    // Initialise section
    this.init();
  }


  Product.prototype = $.extend({}, Product.prototype, {

    init: function() {
      this.productFormSetup();
      this.initBreakpoints();
      stickybits('.product__meta-wrapper', {stickyBitStickyOffset: 110});
      // this.productImageSetup();
      // this.createImageSlider();
    },


    initBreakpoints: function() {
      var self = this;

      enquire.register(theme.mq.mediumDown, {
        match: function() {
          self.createImageSlider();

          if (self.settings.enableImageZoom && !theme.config.isTouch) {
            self.destroyImagesZoom();
          };

          self.destroyThumbnailScroll();
        }
      });

      enquire.register(theme.mq.largeUp, {
        match: function() {
          self.destroyImageSlider();

          if (self.settings.enableImageZoom && !theme.config.isTouch) {
            self.initImagesZoom();            
          }

          self.initThumbnailScroll();
        }
      });
    },


    productFormSetup: function() {
      this.initQtySelector();
      this.initAjaxProductForm();
      this.initVariants();
    },

    productImageSetup: function() {
      // this.initImageSwitch();
    },


    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelectorRadio,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productObject
      }

      this.variants = new slate.Variants(options);

      this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
      this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
    },


    updatePrice: function(evt) {

      var variant = evt.variant;

      if (variant) {
        // Update current price
        $(this.selectors.price).html(slate.Currency.formatMoney(variant.price, theme.settings.moneyFormat));

        if (variant.compare_at_price > variant.price) {

          // If on sale, update compare at price (aka regular price)
          $(this.selectors.comparePrice).html(slate.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
        }
      }
    },


    updateCartButton: function(evt) {

      var variant = evt.variant;
      var $dynamicPaymentButton;

      if (this.settings.showPaymentButton) {
        $dynamicPaymentButton = $('.shopify-payment-button');
      }

      if (variant) {

        if (variant.available) {

          // Remove disabled attribute and show Add to Cart text
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).html(theme.strings.addToCart);

          if (this.settings.showPaymentButton) {
            $dynamicPaymentButton.show();
          }

        } else {

          // Add disabled attribute and show Sold Out text
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.soldOut);
          if (this.settings.showPaymentButton) {
            $dynamicPaymentButton.hide();
          }
        }

      } else {

        // If variant does not exist 
        // Add disabled attribute and show Unavailable text
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).html(theme.strings.unavailable);
        if (this.settings.showPaymentButton) {
          $dynamicPaymentButton.hide();
        }
      }
    },


    updateVariantImage: function(evt) {
      
      // variantImageChange evt stores our variant object
      var variant = evt.variant;

      // These size variables aren't needed for current slider implementation
      // var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      // var zoomSizedImgUrl;

      // if (this.settings.enableImageZoom && theme.config.isTouch) {
      //   zoomSizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
      // }

      // Retrieve index of our new image
      var $newImage = $('.product__image-slide[data-id="' + variant.featured_image?.id + '"]');
      var imageIndex = this._slideIndex($newImage.closest('.product__image-slide'));

      // If there is no index, slider is not initalized
      if (typeof imageIndex === 'undefined') {
        return;
      }

      // Go to slide
      this.$productMainSlider.slick('slickGoTo', imageIndex);
    },


    initQtySelector: function() {

      $(this.selectors.qtyDecrease).on('click', function(evt) {
        var target = evt.currentTarget;
        target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
      });

      $(this.selectors.qtyIncrease).on('click', function(evt) {
        var target = evt.currentTarget;
        target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
      });
    },


    initAjaxProductForm: function() {
      // If we are using a AJAX drawer, pass our form to AjaxProduct function
      if (theme.settings.cartType === 'drawer') {
        new theme.AjaxProduct($(this.selectors.formContainer));
      }
    },


    /**
     * Configures the thumbnail / image switching behaviour. This works if using
     * `a` elements to wrap our thumbnails, as it will prevent default behaviour.
     * We're not currently using this, but opting for `div` elements and Slick
     * sliders `asNavFor` functionality which links the thumbnail slider to
     * the main slider.
     */

    initImageSwitch: function() {

      // If thumbs don't exist, return
      if (!$(this.selectors.productThumbImageWrapper).length) {
        return;
      }

      var self = this;

      // Prevent default behaviour on click of thumbs
      $(this.selectors.productThumbImageWrapper).on('click', function(evt) {
        evt.preventDefault();
      });
    },


    /**
     * Initialise zoom for product images
     */
    initImagesZoom: function($image) {

      $(this.selectors.productImageWrapper).find(selectors.zoomImage).each(function(index, element) {

        // Get URL of zoomed image which is stored in a data-attribute
        var largeImage = $(element).parent().data('zoom-size');


        /**
         * 1. In case we're using an anchor element, we prevent default behaviour.
         * 2. We use a `custom` zoom behaviour that's been added to the zoom.js
         *    script. This allows the user to click to zoom, and exit by either
         *    click or mouseleave events.
         * 3. Set touch to false. However, the zoom still seems to work on iOS.
         */

        $(element).parent()
        .on('click', function(evt) {
          evt.preventDefault(); /* [1] */
        })
        .zoom({
          on: 'custom', /* [2] */
          url: largeImage,
          duration: 180,
          touch: false, /* [3] */
          onZoomIn: function() {
            $(this).addClass(config.activeZoom);
          },
          onZoomOut: function() {
            $(this).removeClass(config.activeZoom);
          }
        });
      });
    },


    destroyImagesZoom: function() {
      $(this.selectors.productImageWrapper).find(selectors.zoomImage).each(function(index, element) {
        $(element).trigger('zoom.destroy');
      });
    },


    initThumbnailScroll: function() {
      $('.product__image-slide').each(function(index, element){
        var $this = $(this);
        var position = $this.position();
        var id = $this.attr('data-id');

        $this.scrollspy({
          min: position.top - 50,
          max: position.top + $this.height(),
          onEnter: function onEnter(element, index) {
            $('.product__thumb-wrapper[data-id=' + id + ']').addClass('product__thumb-wrapper--is-active');
          },
          onLeave: function onLeave(element, index) {
            $('.product__thumb-wrapper[data-id=' + id + ']').removeClass('product__thumb-wrapper--is-active');
          }
        });
      });
    },


    destroyThumbnailScroll: function() {
      $('.product__image-slide').each(function(index, element){
        var $this = $(this);

        $this.scrollspy({}, 'destroy');
      });
    },


    /**
     * This function creates the main slider
     */

    createImageSlider: function() {

      // Check there are multiple images. If not, return.
      if (!this.$productMainSlider.length || $(this.selectors.productImageWrapper).length < 2) {
        return;
      }

      this.settings.hasMultipleImages = true;

      this.$productMainSlider.slick({
        arrows: true,
        prevArrow: $('.slideshow__arrow--prev'),
        nextArrow: $('.slideshow__arrow--next'),
        dots: false,
        adaptiveHeight: true,
        rows: 0
      });

      this.settings.slickMainInitialized = true;


      // Set starting slide for both sliders
      // var $activeSlide = this.$productMainSlider.find('.product__image-slide--starting');
      // var startIndex = this._slideIndex($activeSlide);


      // Lame way to prevent duplicate event listeners
      // this.$productMainSlider.off('init');
      // this.$productMainSlider.off('beforeChange');
      // this.$productMainSlider.on('init', this.mainSlideInit.bind(this));
      // this.$productMainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
    },


    destroyImageSlider: function() {
      if (this.$productMainSlider && this.settings.slickMainInitialized) {
        this.$productMainSlider.slick('unslick');
        this.settings.slickMainInitialized = false;
      }
    },


    mainSlideInit: function(event, slick) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find(selectors.currentSlide);
    },


    beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find(selectors.currentSlide);
      var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
    },


    // Get slide index
    _slideIndex: function($el) {
      return $el.data('index');
    },


    onSelect: function() {
      theme.Collapsibles.init();
    }

  });

  return Product;

})();










/*==============================================================================
  #Collection
==============================================================================*/

theme.Collection = (function() {

  var selectors = {};

  var config = {};

  function Collection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    // var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    this.settings = {};

    // Initialise section
    this.init();
  }


  Collection.prototype = $.extend({}, Collection.prototype, {

    init: function() {
      this.collectionSort();
    },

    collectionSort: function() {
      var $collectionSort = $('.js-collection-sort');

      if (!$collectionSort.length) {
        return;
      }

      $collectionSort.on('change.collection', function() {
        location.href = '?sort_by=' + $(this).val();
      });
    }

  });

  return Collection;

})();











/*==============================================================================
  #Collection List Section
==============================================================================*/

theme.CollectionListSection = (function() {

  var slideCount = 0;

  function CollectionListSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var wrapper = this.wrapper = '.collection-list__content';

    var slider = this.slider = '.js-collection-list-slider--' + sectionId;

    var $slider = $(slider);


    this.defaults = {
      accessibility: true,
      infinite: true,
      arrows: this.options['showArrows'],
      autoplay: this.options['isAutoplay'],
      autoplaySpeed: this.options['autoplaySpeed'],
      prevArrow: $('.slideshow__arrow--prev'),
      nextArrow: $('.slideshow__arrow--next'),
      dots: this.options['showDots'],
      touchThreshold: 20,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0
    };

    this.sliderActive = false;

    slideCount = this.options['slideCount'];

    // Override slidesToShow/Scroll if there are not enough blocks
    if (slideCount < this.defaults.slidesToShow) {
      this.defaults.slidesToShow = slideCount;
      this.defaults.slidesToScroll = slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    this.init($slider, this.defaults);

  }


  CollectionListSection.prototype = $.extend({}, CollectionListSection.prototype, {
    onUnload: function() {
      $(this.slider).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.collection-list__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider).slick('slickGoTo', slideIndex);
    },

    init: function(obj, args) {
      if (this.sliderActive) {
        obj.slick('unslick');
        this.sliderActive = false;
      }

      obj.slick(args);
      this.sliderActive = true;
    },

    destroy: function(obj) {
      if (this.sliderActive) {
        obj.slick('unslick');
        this.sliderActive = false;
      }
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return CollectionListSection;
})();










/*==============================================================================
  #SlideshowSection
==============================================================================*/

/**
 * We store our slideshows in an object
 */
theme.slideshows = {};

theme.SlideshowSection = (function() {

  function SlideshowSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get slideshow by ID
    var slideshow = this.slideshow = '#Slideshow--' + sectionId;

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var $imageContainer = $(container).find('.slideshow');

    // Load image section allows for adding classes whilst loading so we can
    // animate
    if ($imageContainer.length) {
      theme.loadImageSection($imageContainer);
    }


    this.init();
  }


  SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
    init: function() {

      // Prevent slideshows from initializing on top of themselves
      this.onUnload();

      // Store slideshow as jQuery variable
      var $slideshow = $(this.slideshow);
      
      // Store options for Slick Slider
      var args = {
        autoplay: this.options['isAutoplay'],
        autoplaySpeed: this.options['autoplaySpeed'],
        arrows: this.options['showArrows'],
        dots: this.options['showDots'],
        prevArrow: $('.slideshow__arrow--prev'),
        nextArrow: $('.slideshow__arrow--next')
      };

      // Pass slideshow into the theme.slideshows object
      theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);

    },


    /**
     * Shopify Theme Editor events
     */

    forceReload: function() {
      this.init();
    },

    // On unload, destroy slideshow
    onUnload: function() {
      if (theme.slideshows[this.slideshow]) {
        theme.slideshows[this.slideshow].destroy();
        delete theme.slideshows[this.slideshow];
      }
    },

    // When working on the section, pause the slideshow if it has autoplay
    onSelect: function() {
      $(this.slideshow).slick('slickPause');
    },

    // When leaving the section, play the slideshow if it has autoplay
    onDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    },

    // On block select, ignore cloned slides, go to selected slide, and pause
    // autoplay
    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $('.slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    // On block deselect, play slideshow if it has autoplay
    onBlockDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    }
  });

  return SlideshowSection;
})();











/*==============================================================================
  #Contact Section
  - This features a Google Map API integration. JS is largely based off
    Debut theme by Shopify as they have a solid solution.
==============================================================================*/

theme.ContactSection = (function() {

  var config = {
    zoom: 15
  };

  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="contact-section"]',
    mapSection: '.map-section',
    map: '[data-map]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  var image = $(selectors.map).attr('data-marker');

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapSection).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };


  function ContactSection(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  ContactSection.prototype = $.extend({}, ContactSection, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              zoomControl: true,
              center: results[0].geometry.location,
              draggable: true,
              clickableIcons: false,
              scrollwheel: true,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
              styles: [
                {
                  "elementType": "geometry",
                  "stylers": [{"color": "#f5f5f5"}]
                },
                {
                  "elementType": "labels.icon",
                  "stylers": [{"visibility": "off"}]
                },
                {
                  "elementType": "labels.text.fill",
                  "stylers": [{"color": "#616161"}]
                },
                {
                  "elementType": "labels.text.stroke",
                  "stylers": [{"color": "#f5f5f5"}]
                },
                {
                  "featureType": "administrative.land_parcel",
                  "elementType": "labels.text.fill",
                  "stylers": [{"color": "#bdbdbd"}]
                },
                {
                  "featureType": "poi",
                  "elementType": "geometry",
                  "stylers": [{"color": "#eeeeee"}]
                },
                {
                  "featureType": "poi",
                  "elementType": "labels.text.fill",
                  "stylers": [{"color": "#757575"}]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "geometry",
                  "stylers": [{"color": "#e5e5e5"}]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "labels.text.fill",
                  "stylers": [{"color": "#9e9e9e"}]
                },
                {
                  "featureType": "road",
                  "elementType": "geometry",
                  "stylers": [{"color": "#ffffff"}]
                },
                {
                  "featureType": "road.arterial",
                  "elementType": "labels.text.fill",
                  "stylers": [{"color": "#757575"}]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "geometry",
                  "stylers": [{"color": "#dadada"}]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "labels.text.fill",
                  "stylers": [{"color": "#616161"}]
                },
                {
                  "featureType": "road.local",
                  "elementType": "labels.text.fill",
                  "stylers": [{"color": "#9e9e9e"}]
                },
                {
                  "featureType": "transit.line",
                  "elementType": "geometry",
                  "stylers": [{"color": "#e5e5e5"}]
                },
                {
                  "featureType": "transit.station",
                  "elementType": "geometry",
                  "stylers": [{"color": "#eeeeee"}]
                },
                {
                  "featureType": "water",
                  "elementType": "geometry",
                  "stylers": [{"color": "#c9c9c9"}]
                },
                {
                  "featureType": "water",
                  "elementType": "labels.text.fill",
                  "stylers": [{"color": "#9e9e9e"}]
                }
              ]
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            var marker = new google.maps.Marker({
              icon: image,
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return ContactSection;
})();










/*==============================================================================
  #Blog Section
==============================================================================*/

theme.BlogSection = (function() {


  function BlogSection(container) {
    this.$container = $(container);

    this.initMasonry();
  }

  BlogSection.prototype = $.extend({}, BlogSection, {

    /**
     * Masonry layout for Stories blog. Dependent on masonry.js which is
     * conditionally loaded in `theme.liquid`
     */
    initMasonry: function() {
      $('.grid--masonry').masonry({
        itemSelector: '.grid__item'
      })
    },

    onSelect: function() {
      this.initMasonry();
    }
  });

  return BlogSection;
})();










/*==============================================================================
  #Article Section
==============================================================================*/

theme.ArticleSection = (function() {


  function ArticleSection(container) {
    this.$container = $(container);
  }

  ArticleSection.prototype = $.extend({}, ArticleSection, {
    onBlockSelect: function() {
      if (window.Plyr) {
        const player = new Plyr('#player', {
          controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'],
        });
      }
    }
  });

  return ArticleSection;
})();




















/*==============================================================================
  #TEMPLATES
==============================================================================*/

/*==============================================================================
  #Customer Addresses
  - Largely based off Slate
  - Handles customer addresses functionality
==============================================================================*/

theme.customerAddressesOld = (function() {
  var $newAddressForm = $('#AddressNewForm');
  var $addressForms = $('.js-address-form');

  // If no address forms exist, we don't run the code
  if (!$newAddressForm.length || !$addressForms.length) {
    return;
  }

  // Certain countries require province selection such as Spain, Canada, UAE
  // We use Shopify.CountryProvinceSelector to show/hide the province selector
  if (Shopify) {
    $('.js-address-country').each(function() {
      var $container = $(this);
      var countryId = $container.data('country-id');
      var provinceId = $container.data('province-id');
      var provinceContainerId = $container.data('province-container-id');

      new Shopify.CountryProvinceSelector(
        countryId,
        provinceId,
        {
          hideElement: provinceContainerId
        }
      );
    });
  }


  // Toggle new address form
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  // Toggle edit address form
  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  // Delete address event handler
  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();



theme.customerAddresses = (function() {

  var $addressForms = $('.js-address-form');

  // If no address forms exist, we don't run the code
  if (!$addressForms.length) {
    return;
  }

  // Certain countries require province selection such as Spain, Canada, UAE
  // We use Shopify.CountryProvinceSelector to show/hide the province selector
  if (Shopify) {
    $('.js-address-country').each(function() {
      var $container = $(this);
      var countryId = $container.data('country-id');
      var provinceId = $container.data('province-id');
      var provinceContainerId = $container.data('province-container-id');

      new Shopify.CountryProvinceSelector(
        countryId,
        provinceId,
        {
          hideElement: provinceContainerId
        }
      );
    });
  }

  // Delete address event handler
  $('.js-address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();










/*==============================================================================
  #Customer Login
  - Largely based off Slate
  - Handles login / recover password form
==============================================================================*/

theme.customerLogin = (function() {

  var config = {
    recoverPasswordToggle: '.js-toggle-recover-form',
    recoverPasswordForm: '#RecoverPasswordForm'
  };

  // Check recover password form exist
  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordToggle).on('click', onShowHidePasswordForm);
  // $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();




















/*==============================================================================
  #INIT
==============================================================================*/

theme.init = function() {
  /**
   * Tab Handling
   * We use CSS to remove focus outlines on a lot of elements for aesthetic
   * reasons.
   * In order to maintain accessibility, we can recognise if a user is tabbing
   * and add an `is-tabbing` class which will allow us to add focus outlines in 
   * the CSS.
   */

  $(document.documentElement).on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      $(document.documentElement).addClass('is-tabbing');
      $(document.documentElement).off('keyup.tab');
    }
  });


  /**
   * SMOOTH SCROLLING for In-page anchor links
   * Based on:
   * https://stackoverflow.com/questions/7717527/smooth-scrolling-when-clicking-an-anchor-link
   * - 150 offset is based on desktop fixed header size
   */
  $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();

      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top + (-110)
      }, 500);
  });


  theme.setBreakpoints();
  theme.Cart.init();
  theme.Modals.init();
  theme.Popovers.init();
  theme.Collapsibles.init();
  theme.ajaxNewsletterForm();


  // Initialse PLYR video
  // https://github.com/sampotts/plyr

  if (window.Plyr) {
    const player = new Plyr('#player', {
      controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'],
    });
  }
};











/*==============================================================================
  #DOC READY
==============================================================================*/

$(document).ready(function() {

  theme.init();

  var sections = new theme.Sections();
  sections.register('collection-template-section', theme.Collection);
  sections.register('product-template-section', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('drawer-nav-section', theme.DrawerNavSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('blog-template-section', theme.BlogSection);
  sections.register('article-stories-template-section', theme.ArticleSection);
  sections.register('collection-list-section', theme.CollectionListSection);
  sections.register('contact-section', theme.ContactSection);


  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });


  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'table-wrapper-overflow',
  });


  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

});

(function() {
  if (typeof(productOptions) != "undefined") {
    for (i = 0; i < productOptions.length; i++) {
      const vowels = ['a', 'e', 'i', 'o', 'u'];
      const firstOptionLetter = productOptions[i][i][0].toLowerCase();
      let indef = 'a';

      if (vowels.includes(firstOptionLetter)) {
        indef = 'an';
      };

      const select = document.querySelectorAll('.single-option-selector')[i];
      const options = select.querySelectorAll('option');

      if (options.length > 1) {
        let option = new Option('Pick ' + indef + ' ' + productOptions[i][i], '');

        select.add(option, select.firstChild);
        select.selectedIndex = 0;
      }
    }
  }
})();